import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { PortfolioAccountOverview } from '../components/portfolio/PortfolioAccountOverview';
import { AccountDetailsPanel } from '../components/portfolio/AccountDetailsPanel';
import { PortfolioChart } from '../components/portfolio/PortfolioChart';
import { BalancesSection } from '../components/portfolio/BalancesSection';
import { TransactionsSection } from '../components/portfolio/TransactionsSection';
import { motion } from 'framer-motion';
type AccountType = 'overview' | 'main' | 'futures' | 'earn';
export function PortfolioPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const accountParam = searchParams.get('account') as AccountType | null;
  const [activeAccount, setActiveAccount] = useState<AccountType>(accountParam || 'overview');
  // Update active account when URL parameter changes
  useEffect(() => {
    if (accountParam && ['overview', 'main', 'futures', 'earn'].includes(accountParam)) {
      setActiveAccount(accountParam as AccountType);
    }
  }, [accountParam]);
  // Update URL when account changes
  const handleAccountChange = (account: AccountType) => {
    setActiveAccount(account);
    if (account === 'overview') {
      setSearchParams({});
    } else {
      setSearchParams({
        account
      });
    }
  };
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-2460">
      <Sidebar data-id="element-2461" />

      <div className="flex-1 flex flex-col min-w-0 mesh-bg" data-id="element-2462">
        <Header data-id="element-2463" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6 relative z-0" data-id="element-2464">
          {/* Account Navigation Tabs */}
          <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide" data-id="element-2465">
            <button onClick={() => handleAccountChange('overview')} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap flex-shrink-0 ${activeAccount === 'overview' ? 'bg-brand-purple/20 backdrop-blur-sm text-white border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)]' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-2466">
              Overview
            </button>
            <button onClick={() => handleAccountChange('main')} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap flex-shrink-0 ${activeAccount === 'main' ? 'bg-brand-purple/20 backdrop-blur-sm text-white border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)]' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-2467">
              Main
            </button>
            <button onClick={() => handleAccountChange('futures')} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap flex-shrink-0 ${activeAccount === 'futures' ? 'bg-brand-purple/20 backdrop-blur-sm text-white border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)]' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-2468">
              Futures
            </button>
            <button onClick={() => handleAccountChange('earn')} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap flex-shrink-0 ${activeAccount === 'earn' ? 'bg-brand-purple/20 backdrop-blur-sm text-white border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)]' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-2469">
              Earn
            </button>
          </div>

          {/* Account Content */}
          <motion.div key={activeAccount} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35
        }} data-id="element-2470">
            {activeAccount === 'overview' && <PortfolioAccountOverview data-id="element-2471" />}

            {activeAccount !== 'overview' && <div className="flex flex-col lg:grid lg:grid-cols-[1fr_280px] xl:grid-cols-[1fr_320px] gap-4 md:gap-6 min-w-0" data-id="element-2472">
                {/* Left: Chart and Content */}
                <div className="space-y-4 md:space-y-6 order-2 lg:order-1 min-w-0" data-id="element-2473">
                  <PortfolioChart accountType={activeAccount} data-id="element-2474" />
                  <BalancesSection accountType={activeAccount} data-id="element-2475" />
                  <TransactionsSection accountType={activeAccount} data-id="element-2476" />
                </div>

                {/* Right: Account Details Panel */}
                <div className="order-1 lg:order-2 min-w-0" data-id="element-2477">
                  <AccountDetailsPanel accountType={activeAccount} data-id="element-2478" />
                </div>
              </div>}
          </motion.div>
        </main>
      </div>
    </div>;
}